import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  editMarketingSegmentsCustomerFailed,
  editMarketingSegmentsCustomerStart,
  editMarketingSegmentsCustomerSuccess,
  getEditableSegmentsCustomerFailed,
  getEditableSegmentsCustomerStart,
  getEditableSegmentsCustomerSuccess,
  getMarketingSegmentsCustomersFailed,
  getMarketingSegmentsCustomersStart,
  getMarketingSegmentsCustomersSuccess
} from 'redux/actions/quote_marketing_segments';


export const getQuoteMarketingSegmentsCustomers = async ({dispatch}) => {
  try {
    dispatch(getMarketingSegmentsCustomersStart());
    const {data} = await api.get(`${shopManagerApi}/store/customers?searchCriteria[pageSize]=0`);
    dispatch(getMarketingSegmentsCustomersSuccess(data));
  } catch (e) {
    dispatch(getMarketingSegmentsCustomersFailed(e));
  }
};

export const getEditableSegmentsCustomerApi = async ({dispatch, id}) => {
  try {
    dispatch(getEditableSegmentsCustomerStart());
    const { data } = await api.get(`${shopManagerApi}/store/customer/${id}`);
    dispatch(getEditableSegmentsCustomerSuccess(data));
  } catch (e) {
    dispatch(getEditableSegmentsCustomerFailed(e));
  }
};

export const editMarketingSegmentsCustomerApi = async ({dispatch, customerId, customerData}) => {
  try {
    dispatch(editMarketingSegmentsCustomerStart());
    const {data} = await api.put(`${shopManagerApi}/store/customer/${customerId}`, customerData);
    dispatch(editMarketingSegmentsCustomerSuccess(data));
    return true;
  } catch (e) {
    dispatch(editMarketingSegmentsCustomerFailed(e));
    return false;
  }
};
